import { PhotoSwipeLightbox } from "vendor";

class ReviewsSliderPDP extends HTMLElement {
  constructor() {
    super();
    this.reviewsSwiper = null;
    this._photoSwipeInstance = null;
    this._pswpDataSource = null;
  }

  connectedCallback() {
    this.waitForSwiper();
    this.addImageClickListeners();
  }

  waitForSwiper() {
    const checkSwiper = () => {
      if (typeof Swiper !== 'undefined') {
        this.initializeSwiper();
      } else {
        setTimeout(checkSwiper, 50);
      }
    };
    checkSwiper();
  }

  addImageClickListeners() {
    this.querySelectorAll('.review-image-clickable').forEach((clickableDiv, idx) => {
      clickableDiv.addEventListener('click', (e) => {
        e.preventDefault();
        this.openLightbox(idx);
      });
    });
  }

  async openLightbox(index) {
    try {
      if (this._photoSwipeInstance) {
        this._photoSwipeInstance.destroy();
        this._photoSwipeInstance = null;
      }
      
      // Build data source as in theme.js
      const clickableDivs = Array.from(this.querySelectorAll('.review-image-clickable'));
      
      const dataSource = clickableDivs.map((clickableDiv) => {
        // Get the img element from within the clickable div
        const image = clickableDiv.querySelector('img');
        
        if (!image) {
          return null;
        }
        
        // Calculate aspect ratio from the thumbnail
        const thumbWidth = parseInt(image.getAttribute('width')) || 84;
        const thumbHeight = parseInt(image.getAttribute('height')) || 118;
        const aspectRatio = thumbHeight / thumbWidth;
        
        return {
          thumbnailElement: image,
          src: clickableDiv.getAttribute('data-review-image') || image.src,
          srcset: clickableDiv.getAttribute('data-review-image') || image.src,
          msrc: image.currentSrc || image.src,
          width: 1200,  // Base width for high-res image
          height: Math.round(1200 * aspectRatio), // Maintain aspect ratio
          alt: image.alt,
          thumbCropped: true
        };
      }).filter(item => item !== null);
      
      this._pswpDataSource = dataSource;
      
      this._photoSwipeInstance = new PhotoSwipeLightbox({
        dataSource,
        pswpModule: () => import('photoswipe'),
        bgOpacity: 1,
        maxZoomLevel: 3,
        closeTitle: 'Close',
        zoomTitle: 'Zoom',
        errorMsg: 'Error loading image',
        arrowPrev: false,
        arrowNext: false,
        counter: false,
        close: false,
        zoom: false
      });
      
      this._photoSwipeInstance.on('uiRegister', () => {
        this._photoSwipeInstance.pswp.ui.registerElement({
          name: 'close-button',
          className: 'pswp__button pswp__button--close circle-button circle-button--xl hover:animate-icon-block',
          ariaLabel: 'Close',
          order: 2,
          isButton: true,
          html: `
            <svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon" viewBox="0 0 16 16">
              <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1"/>
            </svg>
          `,
          onClick: () => {
            this._photoSwipeInstance.pswp.close();
          }
        });

        // Custom prev arrow - positioned on left side
        this._photoSwipeInstance.pswp.ui.registerElement({
          name: 'prev-button',
          className: 'pswp__button pswp__button--arrow pswp__button--arrow--left circle-button circle-button--xl hover:animate-icon-inline',
          ariaLabel: 'Previous',
          order: 1,
          isButton: true,
          html: `
            <svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon" viewBox="0 0 16 16">
              <path d="M10 2L6 8l4 6" stroke="currentColor" stroke-width="1.5" fill="none"/>
            </svg>
          `,
          onClick: () => {
            this._photoSwipeInstance.pswp.prev();
          }
        });

        // Custom next arrow - positioned on right side
        this._photoSwipeInstance.pswp.ui.registerElement({
          name: 'next-button',
          className: 'pswp__button pswp__button--arrow pswp__button--arrow--right circle-button circle-button--xl hover:animate-icon-inline',
          ariaLabel: 'Next',
          order: 3,
          isButton: true,
          html: `
            <svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon" viewBox="0 0 16 16">
              <path d="M6 2l4 6-4 6" stroke="currentColor" stroke-width="1.5" fill="none"/>
            </svg>
          `,
          onClick: () => {
            this._photoSwipeInstance.pswp.next();
          }
        });
      });
      
      this._photoSwipeInstance.init();
      this._photoSwipeInstance.loadAndOpen(index, dataSource);
      
    } catch (error) {
      console.error('ReviewsSliderPDP: Error in openLightbox:', error);
    }
  }

  initializeSwiper() {
    const swiperElement = this.querySelector('[data-swiper-reviews]');
    
    if (swiperElement && typeof Swiper !== 'undefined') {
      this.reviewsSwiper = new Swiper(swiperElement, {
        observer: true,
        observeParents: true,
        slidesPerView: 1.1,
        spaceBetween: 10,
        navigation: {
          nextEl: this.querySelector('.reviews-swiper-button-next'),
          prevEl: this.querySelector('.reviews-swiper-button-prev'),
        },
        pagination: {
          el: this.querySelector('.reviews-swiper-pagination'),
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 1,
            spaceBetween: 8,
          }
        },
        speed: 300,
        touchRatio: 1,
        simulateTouch: true,
        allowTouchMove: true
      });
    }
  }

  disconnectedCallback() {
    if (this.reviewsSwiper) {
      this.reviewsSwiper.destroy();
      this.reviewsSwiper = null;
    }
    if (this._photoSwipeInstance) {
      this._photoSwipeInstance.destroy();
      this._photoSwipeInstance = null;
    }
  }
}

customElements.define('reviews-slider-pdp', ReviewsSliderPDP);